import { render } from "./App.vue?vue&type=template&id=f1408044"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f1408044&lang=scss"

import exportComponent from "D:\\phpStudy\\WWW\\WeCom\\enterprise-wechat---test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__